import type { Path, Deps as UpdaterDeps, VisionPath } from './updater';

type Deps = {
  spawnProcess: (path: Path, hidden?: boolean) => Promise<Pid>;
  terminateProcess: (pid: Pid) => Promise<unknown>;
  pathJoin: UpdaterDeps['pathJoin'];
};

export type Pid = number;

export class VisionRunner {
  constructor(private deps: Deps) {}

  async start(
    dir: NonNullable<VisionPath>,
    { hidden = false } = {},
  ): Promise<number> {
    const { pathJoin, spawnProcess } = this.deps;
    const path = await pathJoin(dir, this.executableName);
    const pid = await spawnProcess(path, hidden);
    return pid;
  }

  async stop(pid: Pid) {
    return this.deps.terminateProcess(pid);
  }

  get executableName() {
    return 'vision.exe';
  }
}
